import React, { useCallback, useEffect, useRef, useState } from "react";
import { useWixInstanceService } from "./../_shared/request-service-provider/wix-instance-context.js";
import { uuid } from "./../wix-rich-content-common/index.js";
import { Iframe } from "./iframe.js";
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const IframeWidget = ({
  widgetId,
  isViewer,
  onHeightChange
}) => {
  const metaSiteId = useWixInstanceService()().metaSiteId;
  const [currId] = useState(() => uuid());
  const isLoadedRef = useRef(false);
  const handleIframeLoad = useCallback(() => {
    if (isLoadedRef.current) {
      return;
    }
    isLoadedRef.current = true;
    window.ricosHtmlPlugins ||= /* @__PURE__ */ new Set();
    window.ricosHtmlPlugins.add(currId);
  }, [currId]);
  useEffect(() => {
    const timeout = setTimeout(handleIframeLoad, 5e3);
    return () => clearTimeout(timeout);
  }, [handleIframeLoad]);
  useEffect(() => {
    if (!onHeightChange) {
      return;
    }
    const handleMessage = (event) => {
      const { type, widgetId: messageWidgetId, height } = event.data || {};
      if (type === "widgetViewer:heightResize" && messageWidgetId === widgetId) {
        onHeightChange(height);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [widgetId, onHeightChange]);
  if (!metaSiteId || !UUID_REGEX.test(metaSiteId) || !UUID_REGEX.test(widgetId)) {
    console.error("IframeWidget: invalid metaSiteId or widgetId");
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Iframe,
    {
      onLoad: handleIframeLoad,
      src: `https://widgets.wixapps.net/${metaSiteId}/${widgetId}`,
      isViewer,
      sandbox: "allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"
    }
  );
};
export {
  IframeWidget
};
//# sourceMappingURL=iframe-widget.js.map
